import { render, staticRenderFns } from "./resourceDelete.vue?vue&type=template&id=6da8c6a1&"
import script from "./resourceDelete.vue?vue&type=script&lang=js&"
export * from "./resourceDelete.vue?vue&type=script&lang=js&"
import style0 from "./resourceDelete.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resourceDelete.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports